var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mun-wrap" },
    [
      _c(
        "div",
        { staticClass: "textarea-wrap" },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              readonly: "",
              autocomplete: "off",
              size: "small"
            },
            model: {
              value: _vm.upLoadData.content,
              callback: function($$v) {
                _vm.$set(_vm.upLoadData, "content", $$v)
              },
              expression: "upLoadData.content"
            }
          }),
          _c("div", { staticClass: "upload-wrap" }, [
            _c(
              "div",
              { staticClass: "upload-photo-wrap" },
              _vm._l(_vm.photoList, function(item, index) {
                return _c("div", { key: index, staticClass: "photo-item" }, [
                  _c(
                    "div",
                    { staticClass: "photo-wrap" },
                    [
                      _c("el-image", {
                        staticClass: "photo",
                        attrs: { src: item.resourceUrl, fit: "contain" },
                        on: {
                          click: function($event) {
                            return _vm.previewImage(item.resourceUrl)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("span", { staticClass: "photo-name" }, [
                    _vm._v(_vm._s(item.resourceName))
                  ])
                ])
              }),
              0
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.videoList.length != 0,
                    expression: "videoList.length != 0"
                  }
                ],
                staticClass: "upload-video-wrap"
              },
              [
                _vm.videoList.length != 0
                  ? _c("div", { staticClass: "item-wrap" }, [
                      _c(
                        "div",
                        {
                          staticClass: "item-left",
                          on: {
                            click: function($event) {
                              _vm.videoShow = true
                            }
                          }
                        },
                        [
                          _vm.imgsrc
                            ? _c("el-image", {
                                staticClass: "photo",
                                attrs: { src: _vm.imgsrc }
                              })
                            : _vm._e(),
                          _c(
                            "span",
                            { staticClass: "start-wrap" },
                            [
                              _c("el-image", {
                                staticClass: "start-icon",
                                attrs: {
                                  src: require("@/assets/img/start.png")
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "item-right" }, [
                        _c("div", { staticClass: "video-name" }, [
                          _vm._v(_vm._s(_vm.videoList[0].name))
                        ])
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm.upLoadData.appletVo
              ? _c("div", { staticClass: "applet-wrap" }, [
                  _c("div", { staticClass: "applet-item" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "item-right" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.upLoadData.appletVo.name))
                      ]),
                      _c("div", { staticClass: "content" }, [
                        _vm._v(" " + _vm._s(_vm.upLoadData.appletVo.url) + " ")
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm.linkList.length != 0
              ? _c("div", { staticClass: "link-wrap" }, [
                  _c("div", { staticClass: "link-item" }, [
                    _c("div", { staticClass: "item-left" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.linkList[0].title))
                      ]),
                      _vm.linkList[0].linkType == "goods"
                        ? _c("div", { staticClass: "content" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.linkList[0].content &&
                                    "商城价:￥" + _vm.linkList[0].price
                                ) +
                                " "
                            )
                          ])
                        : _vm.linkList[0].linkType == "coupon"
                        ? _c("div", { staticClass: "content" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.linkList[0].content &&
                                    "满" +
                                      _vm.linkList[0].couEnableprice +
                                      "减" +
                                      _vm.linkList[0].price
                                ) +
                                " "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "item-right" },
                      [
                        _vm.linkList[0].pictureUrl &&
                        _vm.linkList[0].linkType != "coupon"
                          ? _c("el-image", {
                              staticClass: "photo",
                              attrs: { src: _vm.linkList[0].pictureUrl },
                              on: {
                                click: function($event) {
                                  return _vm.previewImage(
                                    _vm.linkList[0].pictureUrl
                                  )
                                }
                              }
                            })
                          : _c("el-image", {
                              staticClass: "photo",
                              attrs: {
                                src: require("@/assets/img/ticket.jpg")
                              },
                              on: {
                                click: function($event) {
                                  _vm.previewImage(
                                    require("@/assets/img/ticket.jpg")
                                  )
                                }
                              }
                            })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "video-dialog",
          staticStyle: { "margin-top": "0vh" },
          attrs: {
            visible: _vm.videoShow,
            width: "400px",
            "close-on-click-modal": "",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.videoShow = $event
            }
          }
        },
        [
          _vm.videoList.length != 0
            ? _c(
                "video",
                {
                  attrs: {
                    width: "100%",
                    height: "auto",
                    autoplay: "autoplay",
                    controls: "controls"
                  }
                },
                [
                  _c("source", {
                    attrs: {
                      src: _vm.videoList[0].fileFullUrl,
                      type: "video/mp4"
                    }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _c("el-image", {
        ref: "myImg",
        staticClass: "my-preview-image",
        attrs: { src: _vm.previewUrl, "preview-src-list": _vm.previewSrcList }
      }),
      _c("canvas", {
        staticStyle: { display: "none" },
        attrs: { id: "mycanvas" }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-left" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("@/assets/img/applet.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }